import moment from 'moment'

export default (type, data = []) => {
  return data
    .filter(item => {
      return item[type]
    })
    .map(item => {
      return {
        id: item.id,
        comment: item[type],
        date: item.createdAt,
        status: item.status,
        stringDate: moment(item.createdAt).format('DD/MM/YYYY HH:mm').toString(),
        unitName: item.PartnerUnit ? item.PartnerUnit.fantasyName : ''
      }
    })
}
